import { render, staticRenderFns } from "./SettingAlertMail.vue?vue&type=template&id=9b243b8e&scoped=true&"
import script from "./SettingAlertMail.vue?vue&type=script&lang=js&"
export * from "./SettingAlertMail.vue?vue&type=script&lang=js&"
import style0 from "./SettingAlertMail.vue?vue&type=style&index=0&id=9b243b8e&lang=scss&scoped=true&"
import style1 from "./SettingAlertMail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b243b8e",
  null
  
)

export default component.exports